// extracted by mini-css-extract-plugin
export default {"number":"counter-module___number___cf3b802f","button":"counter-module___button___b42b9d09","active":"counter-module___active___e15e8f0f","title":"counter-module___title___d307db1f"};